import Vue from 'vue';
import VueRouter from 'vue-router';
import About from '../views/About';
import Card from '../views/Card';
import Cards from '../views/Cards';
import Store from '../views/Store';
import Error from '../views/Error';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Logout from '../views/Logout';
import Checkout from '../views/Checkout';
import Order from '../views/Order';
import Orders from '../views/Orders';
import Profile from '../views/Profile';
import store from '../store/storage';
import API from "../services/Api";
import parser from '../utils/parser';
import { AUTH_LOGOUT, AUTH_RENEW } from '../store/actions/authentication';

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
    if(!store.getters.isAuthenticated){
        next();
        return;
    }else{
        next("/cards");
        return;
    }
}

const ifAuthenticated = (to, from, next) => {       
    if(store.getters.isAuthenticated){    
        if(to.name == 'Logout'){
            store.dispatch(AUTH_LOGOUT);
            next('/login');
            return;
        }else if(from.name == 'Login'){
            next('/home');
            return;
        }else{    
            var token = store.getters.token;
            API.validateToken(token)
                .then(result=>{
                    if(parser.validateToken(result)){
                        next();
                        return;     
                    }else{                
                        store.dispatch(AUTH_RENEW, {token})
                            .then(()=>{
                                next();
                                return;
                            })  
                            .catch(()=>{
                                next("/login");
                                return;
                            })                 
                    }   
                }).catch(err=>{
                    if(err.status === undefined){
                        console.log("Erro validateToken!")
                        next();
                        return;
                    }
                });     
        }   
    }else{
        next("/login");
        return;
    }
}

const routes = [
    {
        path: '/',
        alias: '/home',
        name: 'Home',
        component: Home,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/card/:id',
        name: 'Card',
        component: Card,
        beforeEnter: ifAuthenticated
    },
    {        
        path: '/cards',
        name: 'Cards',
        component: Cards,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/order',
        name: 'Order',
        component: Order,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/orders',
        name: 'Orders',
        component: Orders,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/store',
        name: 'Store',
        component: Store,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/checkout',
        name: 'Checkout',
        component: Checkout,
        beforeEnter: ifAuthenticated
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        beforeEnter: ifNotAuthenticated
    },
    {
        path: '/logout',
        name: 'Logout',
        component: Logout,
        beforeEnter: ifAuthenticated
    },
    {
        path: '*',
        name: 'Error',
        component: Error
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router;